module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#health",
      toString: function () {
        return this.url;
      }
    }